import { createModule } from 'saga-slice';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as reglementFournisseurService from '../services/reglementFournisseurService';

const reglementFournisseurModule = createModule({
  name: "reglementsFournisseur",
  initialState: {
    list: [],
    loading: false,
    error: null,
    facturesImpayees: [],
    echeances: [],
    cautions: [],
    searchResults: {
      content: [],
      totalElements: 0,
      totalPages: 0,
      number: 0,
      size: 20
    }
  },
  reducers: {
    // List reglements
    listRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    listSuccess: (state, payload) => {
      state.loading = false;
      state.list = payload;
    },
    listEcheanceSuccess: (state, payload) => {
      state.loading = false;
      state.echeances = payload;
    },
    listFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    solderImpaye: (state) => {
      state.loading = true;
      state.error = null;
    },
    annulerReglement: (state) => {
      state.loading = true;
      state.error = null;
    },
    echeanceFournisseur: (state) => {
      state.loading = true;
      state.error = null;
    },
    cautionFournisseur: (state) => {
      state.loading = true;
      state.error = null;
    },
    getReglementsByFournisseurRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    // Create reglement
    createRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createSuccess: (state, { payload }) => {
      state.loading = false;
      state.list.push(payload);
    },
    createFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Update reglement
    updateRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getReglementsByClientRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    listCautionSuccess: (state, payload) => {
      state.loading = false;
      state.cautions = payload;
    },
    updateSuccess: (state, payload) => {
      state.loading = false;
      const index = state.list.findIndex(item => item.id === payload.id);
      if (index !== -1) {
        state.list[index] = payload;
      }
    },
    updateFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Delete reglement
    deleteRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteSuccess: (state, { payload }) => {
      state.loading = false;
      state.list = state.list.filter(item => item.id !== payload);
    },
    deleteFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    // Search reglements
    searchRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    searchSuccess: (state, payload) => {
      state.loading = false;
      state.list = payload;
    },
    searchFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },

    decaisserReglement: (state) => {
      state.loading = true;
      state.error = null;
    },
    getReglementsByInvoiceSuccess: (state, { payload }) => {
      state.loading = false;
    },
    decaisserReglementSuccess: (state, payload) => {
      state.loading = false;
      // Update the payment in the list if it exists there
      const index = state.list.findIndex(item => item.id === payload.id);
      if (index !== -1) {
        state.list[index] = payload;
      }
    },
    getReglementsByInvoiceRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getReglementsByInvoiceFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    getReglementsByFournisseurSuccess: (state, { payload }) => {
      state.loading = false;
      state.searchResults = payload;
    },
    getReglementsByFournisseurFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    decaisserReglementFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    finishFetching: (state) => {
      state.loading = false;
    },
  },
  sagas: (A) => ({
    *[A.listRequest]({ payload }) {
      try {
        const response = yield call(reglementFournisseurService.rechercherReglements, payload);
        yield put(A.listSuccess(response.data));
      } catch (error) {
        yield put(A.listFailure(error.message));
      }
    },
    *[A.solderImpaye]({ payload }) {
      try {
        yield call(reglementFournisseurService.solderImpaye, payload.id);
        yield put(A.finishFetching());
        yield call(payload.onSuccess);
      } catch (error) {
        yield put(A.listFailure(error.message));
      }
    },
    *[A.annulerReglement]({ payload }) {
      try {
        const { id, onSuccess } = payload;
        yield call(reglementFournisseurService.annulerReglement, id);
        yield put(A.finishFetching());
        if (onSuccess) {
          yield call(onSuccess);
        }
      } catch (error) {
        yield put(A.encaisserReglementFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },
    *[A.echeanceFournisseur]({ payload }) {
      try {
        console.log(payload)
        const response = yield call(reglementFournisseurService.getEcheancesFournisseurs, payload);
        console.log(response)
        yield put(A.listEcheanceSuccess(response.data));
      } catch (error) {
        yield put(A.listFailure(error.message));
      }
    },
    *[A.cautionFournisseur]({ payload }) {
      try {
        const response = yield call(reglementFournisseurService.getCautionsFournisseurs, payload);
        yield put(A.listCautionSuccess(response.data));
      } catch (error) {
        yield put(A.listFailure(error.message));
      }
    },
    *[A.getReglementsByFournisseurRequest]({ payload }) {
      try {
        const { fournisseurId, page, size, sortBy, sortDirection, onSuccess, onError } = payload;
        const response = yield call(
          reglementFournisseurService.getReglementsByFournisseur,
          fournisseurId,
          page,
          size,
          sortBy,
          sortDirection
        );
        yield put(A.getReglementsByFournisseurSuccess(response.data));
        if (onSuccess) {
          yield call(onSuccess, response.data);
        }
      } catch (error) {
        yield put(A.getReglementsByClientFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },
    *[A.decaisserReglement]({ payload }) {
      try {
        const { id, dateDecaissement, onSuccess, onError } = payload;
        const response = yield call(
          reglementFournisseurService.decaisserReglement,
          id,
          { dateDecaissement: dateDecaissement }
        );
        yield put(A.decaisserReglementSuccess(response.data));
        if (onSuccess) {
          yield call(onSuccess, response.data);
        }
      } catch (error) {
        yield put(A.decaisserReglementFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },

    *[A.createRequest]({ payload }) {
      try {
        const response = yield call(reglementFournisseurService.createReglement, payload.data);
        yield put(A.createSuccess(response.data));
        if (payload.onSuccess) {
          payload.onSuccess(response.data);
        }
      } catch (error) {
        yield put(A.createFailure(error.message));
        if (payload.onError) {
          payload.onError(error);
        }
      }
    },

    *[A.updateRequest]({ payload }) {
      try {
        const response = yield call(reglementFournisseurService.updateReglement, payload.id, payload.data);
        yield put(A.updateSuccess(response.data));
        if (payload.onSuccess) {
          payload.onSuccess(response.data);
        }
      } catch (error) {
        yield put(A.updateFailure(error.message));
        if (payload.onError) {
          payload.onError(error);
        }
      }
    },

    

    *[A.getReglementsByInvoiceRequest]({ payload }) {
          try {
            const { numero, onSuccess, onError } = payload;
            const response = yield call(reglementFournisseurService.getReglementsByInvoice, numero);
            yield put(A.getReglementsByInvoiceSuccess(response.data));
            if (onSuccess) {
              yield call(onSuccess, response.data);
            }
          } catch (error) {
            yield put(A.getReglementsByInvoiceFailure(error.message));
            if (payload.onError) {
              yield call(payload.onError, error);
            }
          }
        },

    *[A.deleteRequest]({ payload }) {
      try {
        yield call(reglementFournisseurService.deleteReglement, payload.id);
        yield put(A.deleteSuccess(payload.id));
        if (payload.onSuccess) {
          payload.onSuccess();
        }
      } catch (error) {
        yield put(A.deleteFailure(error.message));
        if (payload.onError) {
          payload.onError(error);
        }
      }
    },


  }),
});

export const reglementsFournisseurActions = reglementFournisseurModule.actions;
export default reglementFournisseurModule;
